import React, {useEffect} from 'react';

import {useHistory} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {clearMessages} from '../action/messageActions';

export default function MessageClearer() {
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        return history.listen(() => {
            // Clear message on every page change
            dispatch(clearMessages());
        });
    }, [history]);

    return null;
}
